/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
  BUTTON_COLOR,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';
import { bafTariffs, CALL_GENERIC_900, mobileTariffs, PHONE_900, URLS } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      REDIRECT_TO_ALT_BUY_PROCESS_URL: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Ya tienes {bafName} en esa dirección',
          msg: [
            `Puedes continuar contratando unicamente la {lmaName} a un precio exclusivo de {lmaPrice}€/mes`,
          ],
          buttons: [
            {
              label: 'Continuar',
              color: BUTTON_COLOR.BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            },
            {
              label: "Ver tarifas móviles Movistar",
              link: URLS.MOBILE_TARIFF_LIST,
              color: BUTTON_COLOR.WHITE_BLUE,
              desktopProps: {
                size: {
                  w: BUTTON_WIDTH.LIQUID_DOPPED,
                  h: BUTTON_HEIGHT.REGULAR,
                },
              },
            }
          ],
          errorName: "producto incompatible",
        },
      },
      INCOMPATIBLE_PRODUCT: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Lo sentimos, no podemos continuar con tu pedido online',
          msg: [
            `Ponte en contacto gratis en el ${PHONE_900} y un asesor comercial te ayudará a gestionar tu pedido. También puedes consultar otras tarifas`,
          ],
          buttons: [CALL_GENERIC_900, bafTariffs.showListButton],
          errorName: "producto incompatible",
        },
      },
      MAX_CARDINALITY_REACHED: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: 'Producto ya contratado',
          msg: ['Actualmente ya tienes contratado este producto'],
          errorName: 'produco ya contratado - cardinalidad superada',
        },
      },
      DEFAULT_ERROR: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          title: "Upss… algo ha ido mal",
          msg: [
            "Se ha producido un error al generar tu pedido.",
            `Por favor, reinténtalo más tarde o llámanos gratis al ${PHONE_900} para que podamos gestionarlo.`,
            "Sentimos las molestias.",
          ],
          buttons: [CALL_GENERIC_900],
          errorName: "error generico",
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
